import { render, staticRenderFns } from "./auction-commission-table.vue?vue&type=template&id=34f2dc94&scoped=true&"
import script from "./auction-commission-table.vue?vue&type=script&lang=js&"
export * from "./auction-commission-table.vue?vue&type=script&lang=js&"
import style0 from "./auction-commission-table.vue?vue&type=style&index=0&id=34f2dc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2dc94",
  null
  
)

export default component.exports